/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Manage_DescriptionInputs */

const en_plan_manage_description = /** @type {(inputs: Plan_Manage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your benefits and manage your subscription.`)
};

const es_plan_manage_description = /** @type {(inputs: Plan_Manage_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tus beneficios y administra tu suscripción.`)
};

/**
* | output |
* | --- |
* | "Review your benefits and manage your subscription." |
*
* @param {Plan_Manage_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_manage_description = /** @type {((inputs?: Plan_Manage_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Manage_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_manage_description(inputs)
	return en_plan_manage_description(inputs)
});